import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface WindowState {
    width: number
    height: number
    size: 'lg' | 'xs' | 'xxs' | 'sm' | 'md' | 'none'
    isMinSize: boolean
}

const initialState: WindowState = {
    width: typeof window !== 'undefined' ? window.innerWidth : 0,
    height: typeof window !== 'undefined' ? window.innerHeight : 0,
    size: 'none',
    isMinSize: false,
}

const windowSlice = createSlice({
    name: 'window',
    initialState,
    reducers: {
        setWindowSize: (state, action: PayloadAction<WindowState>) => {
            state.width = action.payload.width
            state.height = action.payload.height
            state.size = action.payload.size
            state.isMinSize = action.payload.isMinSize
        },
    },
})

export const { setWindowSize } = windowSlice.actions
export default windowSlice.reducer
